export default __webpack_public_path__ + "static/media/progress.cfa13502.png";